import styled from "styled-components";
import { List } from "../../../util";

export const JfsList = styled(List).attrs((props: any) => ({}))`
  overflow: hidden;
`;
